import { FormLabel as BaseLabel } from "@chakra-ui/react";
import React from "react";

export const FormLabel = ({ children }: any) => {

    return (
        <BaseLabel fontSize={14} mb={0}>{children}</BaseLabel>
    )
}